// How many product cards the article sidebar renders: one staff-pick card plus
// the list cards below it.
//
// Shared by the server (the brand-filtered pool's `limit`) and the client
// (`FeaturedProducts`, which shuffles the rotation pool and slices to this
// count). They must agree, or a brand sidebar silently renders fewer cards than
// the featured one.
//
// This module is deliberately dependency-free: `FeaturedProducts` is a client
// component, and importing the `@/lib/sidebar` barrel there would pull
// `load.ts` — `next/cache` plus the postgres client — into the client bundle.
export const SIDEBAR_PRODUCT_COUNT = 3

// How many stories the Related Stories rail renders: one lead card plus two
// rows below it.
export const SIDEBAR_ARTICLE_COUNT = 3
